import {
  SearchUserMasterRequest,
  UpdateUserMasterRequest,
  DeleteUserMasterRequest,
  GetDivisionListRequest,
} from 'api-types/src/types/user-mast';
import { ResponseGenerator } from 'common/type';
import { call, put, takeLatest } from 'redux-saga/effects';

import {
  addUserMastApi,
  deleteUserMastApi,
  getDetailUserMastApi,
  getDivisionListApi,
  getMenuAuthorityApi,
  getUserGroupApi,
  getUserMastListApi,
  initializationPasswordApi,
  updateUserMastApi,
} from './api';
import {
  getMenuAuthoritySuccess,
  getMenuAuthority,
  getMenuAuthorityFailure,
  filterUserMast,
  filterUserMastSuccess,
  filterUserMastFailure,
  getUserGroup,
  getUserGroupSuccess,
  getUserGroupFailure,
  getDivisionList,
  getDivisionListSuccess,
  getDivisionListFailure,
  getInitializationPw,
  getInitializationPwSuccess,
  getInitializationPwFailure,
  addUserMast,
  addUserMastSuccess,
  addUserMastFailure,
  getDetailUserMast,
  getDetailUserMastSuccess,
  getDetailUserMastFailure,
  deleteUserMast,
  deleteUserMastSuccess,
  deleteUserMastFailure,
  updateUserMast,
  updateUserMastSuccess,
  updateUserMastFailure,
} from './slice';

function* getMenuAuthoritySaga() {
  try {
    const response: ResponseGenerator = yield call(getMenuAuthorityApi);
    yield put(getMenuAuthoritySuccess(response?.data));
  } catch (error) {
    yield put(getMenuAuthorityFailure());
  }
}

function* filterUserMastSaga({ payload }: { payload: SearchUserMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(getUserMastListApi, payload);
    yield put(filterUserMastSuccess(response.data));
  } catch (error) {
    yield put(filterUserMastFailure());
  }
}

function* getUserGroupSaga() {
  try {
    const response: ResponseGenerator = yield call(getUserGroupApi);
    yield put(getUserGroupSuccess(response.data));
  } catch (error) {
    yield put(getUserGroupFailure());
  }
}

function* getDivisionListSaga({ payload }: { payload: GetDivisionListRequest }) {
  try {
    const response: ResponseGenerator = yield call(getDivisionListApi, payload);
    yield put(getDivisionListSuccess(response.data));
  } catch (error) {
    yield put(getDivisionListFailure());
  }
}

function* getInitializationPwSaga() {
  try {
    const response: ResponseGenerator = yield call(initializationPasswordApi);
    yield put(getInitializationPwSuccess(response.data));
  } catch (error) {
    yield put(getInitializationPwFailure());
  }
}

function* addUserMastSaga({ payload }: { payload: { body: UpdateUserMasterRequest; onSuccess: () => void } }) {
  const { body, onSuccess } = payload;
  try {
    const response: ResponseGenerator = yield call(addUserMastApi, body);
    yield put(addUserMastSuccess(response));
    if (response?.data) {
      onSuccess();
    }
  } catch (error) {
    yield put(addUserMastFailure());
  }
}

function* getDetailUserMastSaga({ payload }: { payload: { USER_ID: string; onFail?: () => void } }) {
  const { USER_ID, onFail } = payload;
  const response: ResponseGenerator = yield call(getDetailUserMastApi, { USER_ID: USER_ID });
  if (response?.data) {
    yield put(getDetailUserMastSuccess(response.data));
  } else {
    yield put(getDetailUserMastFailure());
    if (onFail) onFail();
  }
}

function* deleteUserMastSaga({ payload }: { payload: { body: DeleteUserMasterRequest; onSuccess: () => void } }) {
  const { body, onSuccess } = payload;
  try {
    const response: ResponseGenerator = yield call(deleteUserMastApi, body);
    yield put(deleteUserMastSuccess(response));
    if (response?.data) {
      onSuccess();
    }
  } catch (error) {
    yield put(deleteUserMastFailure());
  }
}

function* updateUserMastSaga({ payload }: { payload: { body: UpdateUserMasterRequest; onSuccess: () => void } }) {
  const { body, onSuccess } = payload;
  try {
    const response: ResponseGenerator = yield call(updateUserMastApi, body);
    yield put(updateUserMastSuccess(response));
    if (response?.data) {
      onSuccess();
    }
  } catch (error) {
    yield put(updateUserMastFailure());
  }
}

function* watchUserMast() {
  yield takeLatest(getMenuAuthority, getMenuAuthoritySaga);
  yield takeLatest(filterUserMast, filterUserMastSaga);
  yield takeLatest(getUserGroup, getUserGroupSaga);
  yield takeLatest(getDivisionList, getDivisionListSaga);
  yield takeLatest(getInitializationPw, getInitializationPwSaga);
  yield takeLatest(addUserMast, addUserMastSaga);
  yield takeLatest(getDetailUserMast, getDetailUserMastSaga);
  yield takeLatest(deleteUserMast, deleteUserMastSaga);
  yield takeLatest(updateUserMast, updateUserMastSaga);
}
export default watchUserMast;
